// removed by extract-text-webpack-plugin
module.exports = {"footer-links":"FooterLinks__footer-links","footerLinks":"FooterLinks__footer-links","copy-rights":"FooterLinks__copy-rights","copyRights":"FooterLinks__copy-rights","copy-right-intellectual":"FooterLinks__copy-right-intellectual","copyRightIntellectual":"FooterLinks__copy-right-intellectual","trust-image":"FooterLinks__trust-image","trustImage":"FooterLinks__trust-image","links":"FooterLinks__links","link-columns":"FooterLinks__link-columns","linkColumns":"FooterLinks__link-columns"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/global/GlobalFooter/cards/FooterLinks/FooterLinks.css
// module id = 1383
// module chunks = 8